module.exports = {"450311001":"良丰街道","450311100":"雁山镇","450311101":"柘木镇","450311200":"大埠乡","450311201":"草坪回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450311.json
// module id = 1922
// module chunks = 0